import { createContext, useContext } from 'react'
import { Detail } from './types'

// eslint-disable-next-line import/prefer-default-export
export const MediaDetailContext = createContext<Detail>({} as Detail)

export const useContextMediaDetail = () => {
  const detail = useContext(MediaDetailContext)
  return detail
}
